<template>
  <section
    class="lp-faq"
    :style="{
      backgroundColor: section.styles.backgroundColor || '#ffffff',
      padding: section.styles.padding || '5rem 1.25rem',
    }"
  >
    <div class="max-w-3xl mx-auto">
      <h2 v-if="section.content.title" class="lp-faq__title">{{ section.content.title }}</h2>
      <div class="lp-faq__list">
        <details
          v-for="(item, index) in section.content.items || []"
          :key="index"
          class="lp-faq__item group"
        >
          <summary class="lp-faq__question">
            <span>{{ item.question }}</span>
            <span class="lp-faq__mark" aria-hidden="true">+</span>
          </summary>
          <p class="lp-faq__answer">{{ item.answer }}</p>
        </details>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    section: { type: Object, required: true },
    preview: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.lp-faq__title {
  font-family: var(--ps-font-display);
  font-size: clamp(1.75rem, 3vw, 2.35rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #0f172a;
  text-align: center;
  margin-bottom: 2rem;
}

.lp-faq__list {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.lp-faq__item {
  border-bottom: 1px solid #e2e8f0;
  padding: 0.35rem 0 0.85rem;
}

.lp-faq__question {
  cursor: pointer;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  font-weight: 700;
  color: #0f172a;
  font-size: 1rem;
  padding: 0.55rem 0;
}

.lp-faq__question::-webkit-details-marker {
  display: none;
}

.lp-faq__mark {
  color: var(--lp-primary-color, #0f766e);
  font-size: 1.25rem;
  font-weight: 500;
  transition: transform 0.2s ease;
  line-height: 1;
}

.lp-faq__item[open] .lp-faq__mark {
  transform: rotate(45deg);
}

.lp-faq__answer {
  margin-top: 0.35rem;
  padding-bottom: 0.35rem;
  font-size: 0.95rem;
  color: #64748b;
  line-height: 1.6;
}
</style>
